var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:(_vm.getStyle),attrs:{"fluid":""}},[_c('v-progress-linear',{attrs:{"color":"#A0A0A0","value":_vm.valueCalculated,"rounded":"","height":"18"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('span',{staticClass:"progress-text"},[_vm._v(" "+_vm._s(_vm.daysTxt)+" ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }